<template>
	<div class="absolute w-screen h-screen bg-blue-500 text-white grid grid-cols-2">
		<div v-for="x in [1, 2, 3, 4]" :key="x" class="border-white border-4 flex items-center justify-center"></div>
	</div>
</template>
